import { Box, Container } from '@mui/material';
import { DELETE_PERIOD, LIST_PERIODS } from "../../../graphql/admin-requests";
import React from 'react';
import PeriodListResults from './PeriodListResults';
import EntityListToolbar from '../subcomponents/EntityListToolbar';
import { useEntityList } from '../../../hooks/useEntityList';
import CUPeriod from "../CreateUpdateComponents/Period";


function PeriodList() {

    const {
        items: periods,
        totalCount,
        limit,
        setLimit,
        offset,
        setOffset,
        updateSearch,
        loadData,
        handleDelete: handleDeletePeriod,
    } = useEntityList({
        listQuery: LIST_PERIODS,
        listDataKey: "allPeriods",
        deleteMutation: DELETE_PERIOD,
        deleteVariableName: "periodUid",
        deleteErrorMessage: "Impossible de supprimer la periode",
        deleteSuccessMessage: "Periode supprimée",
        initialLimit: 5,
    });

    return (
        <Container component="main" maxWidth={false}>
            <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}>
                <Container maxWidth={false}>
                    <EntityListToolbar
                        loadData={loadData}
                        updateSearch={updateSearch}
                        searchPlaceholder="Rechercher une période"
                        CreateComponent={CUPeriod}
                    />
                    <Box sx={{ pt: 3 }}>
                        <PeriodListResults
                            loadData={loadData}
                            periods={periods}
                            limit={limit}
                            offset={offset}
                            totalCount={totalCount}
                            setLimit={setLimit}
                            setOffset={setOffset}
                            handleDeletePeriod={handleDeletePeriod} />
                    </Box>
                </Container>
            </Box>
        </Container >
    )
};

export default PeriodList;
